<template>

	<div class="container-radio-group" :class="direction">
		<div class="title" v-if="title">{{ title }}</div>
		<div class="radio-group">
			<div class="radio-buttons" :class="{titled: !!title}" v-for="(radio, index) in values" :key="index">
				<AppRadioButton
					:index="index"
					:ref="groupId+'-rb-'+index"
					:label="radio"
					:checked="currentSelection !== null && index === currentSelection"
					:direction="direction === 'horizontal' ? 'vertical' : 'horizontal'"
					@radio-toggle="radioToggle"/>
			</div>
		</div>
	</div>

</template>

<script>
import AppRadioButton from "@/shared/components/AppRadioButton.vue";

export default {
	name: "AppRadioButtonGroup",
	components: {
		AppRadioButton
	},
	emits: ["radio-chosen"],
	data() {
		return {
			currentSelection: null,
		};
	},
	props: {
		values: {required: true, validator(prop) {
			return Array.isArray(prop) && prop.every(item => typeof item === "string")
		}},
		direction: {type: String, default: "horizontal", validator(prop) {
			return ["horizontal", "vertical"].includes(prop)
		}},
		title: {type: String, default: null},
		groupId: {type: String, default: "radio-group"},
		selected: {type: Number, default: null},
		allowNoSelection: {type: Boolean, default: false},
	},
	methods: {
		radioToggle(active, index) {
			if(active) {
				for(let i = 0; i < this.values.length; i++) {
					if(i === Number(index)) {
						this.currentSelection = i;
					}
					let targetBtn = this.$refs[this.groupId+'-rb-'+i];
					if(targetBtn && targetBtn[0]) {
						targetBtn[0].toggle(i === Number(index));
					}
				}
			} else {
				if(this.allowNoSelection) {
					this.currentSelection = null;
				} else {
					let targetBtn = this.$refs[this.groupId+'-rb-'+index];
					if(targetBtn && targetBtn[0]) {
						targetBtn[0].toggle(true);
					}
				}
			}
			let emitValue = this.currentSelection !== null ? this.values[this.currentSelection] : null;
			this.$emit("radio-chosen", this.currentSelection, emitValue);
		}
	},
	created() {
		this.currentSelection = handlePreselection(this.values, this.allowNoSelection, this.selected);
	},
	watch: {
		selected(newSelection) {
			this.radioToggle(newSelection !== null, handlePreselection(this.values, this.allowNoSelection, newSelection));
		}
	}
}

function handlePreselection(values, allowNoSelection, selected) {
	let result = null;
	if(!allowNoSelection) {
		if(values.length > 0) {
			if (selected === null) {
				result = 0;
			} else {
				if(selected >= values.length) {
					result = values.length - 1;
				} else if(selected < 0) {
					result = 0;
				} else {
					result = selected;
				}
			}
		} else {
			console.error("AppRadioButtonGroup: No values provided and allowNoSelection is false");
		}
	} else {
		if(selected !== null) {
			if(selected >= values.length) {
				result = values.length - 1;
			} else if(selected < 0) {
				result = 0;
			} else {
				result = selected;
			}
		} else {
			result = selected;
		}
	}
	return result;
}
</script>

<style lang="scss" scoped>

.container-radio-group {
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	.title {
		color: $txt_1;
		font-size: 12px;
		@include noSelect();
	}

	.radio-group {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;
		margin-top: 5px;
	}

	.radio-buttons {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;

		.radio-container {
			margin: 0 20px;

			@media (max-width: 600px) {
				margin: 0 15px;
			}

			@media (max-width: 420px) {
				margin: 0 10px;
			}
		}

		&.titled {
			margin-top: 5px;
		}
	}

	&.vertical {

		.radio-group {
			flex-direction: column;
			flex-wrap: unset;
			justify-content: flex-start;
			align-items: flex-start;
			margin-top: 5px;
		}

		.radio-buttons.titled {
			margin-top: 8px;
		}
	}

}

</style>